import { v4 as uuid } from 'uuid';
import { getDescendantIds, layoutHierarchy } from 'components/OrganizationChart/hierarchy';
import { entityConfig, entityData } from './backendChartAdapter';

export const childEntityTypes = {
    organization: ['division'],
    division: ['department', 'position'],
    department: ['position'],
    position: [],
};

export function createEntityNode(entityType, parent, values) {
    const { prefix } = entityConfig[entityType];
    if (entityType !== 'organization' && !childEntityTypes[parent?.data.entityType]?.includes(entityType)) {
        throw new Error('Invalid parent for this unit.');
    }

    const id = uuid();
    const record = {
        [`${prefix}_id`]: id,
        [`${prefix}_name`]: values.name.trim(),
        [`${prefix}_code`]: values.code?.trim() || null,
        is_active: true,
    };
    const parentRecord = parent?.data.record;
    if (entityType === 'division') record.org_id = parentRecord.org_id;
    if (entityType === 'department') record.div_id = parentRecord.div_id;
    if (entityType === 'position') {
        record.div_id = parentRecord.div_id;
        record.dept_id = parent.data.entityType === 'department' ? parentRecord.dept_id : null;
        record.pos_resource_total = values.resources ?? null;
    }

    return { id: `${entityType}:${id}`, type: 'member', position: { x: 0, y: 0 }, data: entityData(entityType, record) };
}

export function appendEntity(nodes, edges, node, parentId) {
    const nextEdges = parentId ? [...edges, {
        id: `${parentId}-${node.id}`, source: parentId, target: node.id,
        sourceHandle: 'bottom', targetHandle: 'top', type: 'editableOrganization',
        selectable: false, style: { stroke: '#737373', strokeWidth: 1.5 },
    }] : edges;
    return reflowChart([...nodes, node], nextEdges);
}

export function removeEntityBranch(nodes, edges, nodeId) {
    const removedIds = getDescendantIds(nodeId, edges);
    removedIds.add(nodeId);
    return reflowChart(
        nodes.filter(node => !removedIds.has(node.id)),
        edges.filter(edge => !removedIds.has(edge.source) && !removedIds.has(edge.target)),
    );
}

function reflowChart(nodes, edges) {
    return {
        nodes: layoutHierarchy(nodes, edges),
        edges: edges.map(edge => ({ ...edge, data: { ...edge.data, routePoint: null } })),
    };
}
